import { render } from "./CallWaiterButton.vue?vue&type=template&id=1a620553&lang=pug"
import script from "./CallWaiterButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CallWaiterButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__